export default class Graph {
    public adjacencyList: Array<Array<number>> = [];

    public updateList: Array<boolean> = [];

    public addNode() {
      this.adjacencyList.push([]);
      this.updateList.push(true);
    }

    public getNode(index: number): number[] {
      if (this.adjacencyList.length - 1 < index) return [];
      return this.adjacencyList[index];
    }

    public replaceIndex(index1: number, index2: number, num: number) {
      const nodes = this.getNode(index1);
      const index = nodes.findIndex((element:any) => element === index2);
      if (index > -1) {
        nodes[index] = num;
        this.updateList[index1] = true;
      }
    }

    public split(index1: number, index2: number, index3: number) {
      this.replaceIndex(index1, index2, index3);
      this.replaceIndex(index2, index1, index3);
      this.link(index1, index3);
      this.link(index2, index3);
    }

    private replaceNodeFromArray(index: number, array: Array<number>) {
      this.adjacencyList[index] = array;
    }

    public link(index1: number, index2: number) {
      if (this.adjacencyList[index1].indexOf(index2) === -1) {
        this.adjacencyList[index1].push(index2);
        this.updateList[index1] = true;
      }
      if (this.adjacencyList[index2].indexOf(index1) === -1) {
        this.adjacencyList[index2].push(index1);
        this.updateList[index2] = true;
      }
    }

    // index1番からindex2番へのリンクを削除
    public unlink(index1: number, index2: number) {
      const nodes = this.getNode(index1);

      const newArray = nodes.filter((n:number) => n !== index2);
      this.replaceNodeFromArray(index1, newArray);
      this.updateList[index1] = true;
    }

    public clearUpdate() {
      this.updateList.fill(false);
    }

    // 末端
    public isLeaf(index: number) {
      return this.adjacencyList[index].length === 1;
    }

    // 繋がりのあるNodeのリスト
    public group(): Array<number> {
      if (!this.adjacencyList.length) return [];

      // node分の配列を確保して-1で初期化
      // 0番スタートのグループ番号を書き込んでいく
      const groupList = new Array(this.adjacencyList.length);
      groupList.fill(-1);

      let gNumber = 0;
      let index = 0;

      const queue : number[] = []; // First In First Outのキュー

      while (index !== -1) {
        groupList[index] = gNumber;
        queue.push(index);

        while (queue.length) {
          const num = queue[0];
          queue.shift();

          // eslint-disable-next-line no-loop-func
          this.adjacencyList[num].forEach((indexe:number) => {
            if (groupList[indexe] != -1) return;

            groupList[indexe] = gNumber;
            queue.push(indexe);
          });
        }
        index = groupList.indexOf(-1);
        gNumber++;
      }
      return groupList;
    }

    // ループしていない = 枝 の算出
    // -1は枝ではない
    // 0以上は枝番号
    public branch() {
      const result = new Array(this.adjacencyList.length);
      result.fill(-1);

      let gNumber = 0;

      const search = (prevInex: number, index: number) => {
        const nodes = this.adjacencyList[index];
        if (nodes.length > 2) return; // nodeは分岐している

        result[index] = gNumber;

        if (nodes.length <= 1) return; // 末端に到達した

        search(index, nodes[0] != prevInex ? nodes[0] : nodes[1]);
      };

      this.adjacencyList.forEach((nodes:number[], index:number) => {
        if (nodes.length == 1 && result[index] == -1) {
          result[index] = gNumber;
          search(index, nodes[0]);
          gNumber++;
        }
      });
      return result;
    }
}
